export default __webpack_public_path__ + "static/media/45.05fde7ad.png";